import { ApiModel } from './api-model';
import { Language } from './language';
import { Format } from './format';
import { Channel } from './channel';

export class Picture extends ApiModel {
  id: number;
  language: Language;
  channel: Channel;
  isLocked: boolean;
  modified: boolean;
  original: Format;
  format_16_9: Format;
  format_3_4: Format;
  format_4_3: Format;
  duplicatedFromLanguage: Language;
  source: boolean;
  checked: boolean;
  selectable: boolean;
  selected: boolean;
  displayLocked: boolean;

  static getFormats() {
    return ['original', 'format_16_9', 'format_4_3', 'format_3_4'];
  }

  constructor(data: any) {
    super(data);
    this.modified = false;
  }

  get empty() {
    return !this.original && !this.format_16_9 && !this.format_3_4 && !this.format_4_3;
  }

  get hasOriginal() {
    return this.original && (this.original.url || this.original.blob);
  }

  getUrl(format: string, blob = false) {
    if (format === 'original') {
      return this.original.url ? this.original.url : this.original.blob;
    }
    if (this['format_' + format] && this['format_' + format].url) {
      return this['format_' + format].url;
    } else {
      if (blob && this['format_' + format] && this['format_' + format].blob) {
        return this['format_' + format].blob;
      }
      return null;
    }
  }

  changeUrl(url: string) {
    this.format_3_4 = null;
    this.format_4_3 = null;
    this.format_16_9 = null;
    this.original.url = url;
  }
}


// WEBPACK FOOTER //
// ./src/app/models/picture.ts